import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

gsap.config({
    nullTargetWarn: false,
});

const prefersReducedMotion = window.matchMedia(`(prefers-reduced-motion: reduce)`) === true || window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;

if (!prefersReducedMotion) {

    /*
     * Statistic bars homepage header
     */
    const statisticsGraphBars = gsap.utils.toArray('.electric-cars-graph .graph-bar');
    const statisticsGraphBarLast = statisticsGraphBars[statisticsGraphBars.length - 1];

    statisticsGraphBars.reverse();
    statisticsGraphBars.shift();

    statisticsGraphBars.forEach(graph => {
        gsap.from(graph, {
            scrollTrigger: {
                trigger: graph,
                start: 'top bottom',
                end: 'top 120%',
                scrub: 1,
                once: true,
                toggleActions: 'play none none pause'
            },
            height: 0,
            duration: 0.5,
        })
    });

    gsap.to(statisticsGraphBarLast, {
        height: '100%'
    });


    /*
     * Statistics homepage header
     */
    const statistics = gsap.utils.toArray('.paragraph--type--electric-cars-statistics');

    statistics.forEach((statistic, index) => {
        gsap.from(statistic, {
            scrollTrigger: {
                trigger: '.electric-cars-graph',
                start: 'top center',
                end: 'bottom bottom',
                toggleActions: 'play none none none'
            },
            x: -300,
            opacity: 0,
            duration: 1,
            delay: index * 0.2
        });
    });


    /*
     * Teasers
     */
    const bigTeasers = gsap.utils.toArray('.big-teaser');

// Teaser image
    bigTeasers.forEach(teaser => {
        gsap.to(teaser.querySelector('.thumbnail-wrapper'), {
            scrollTrigger: {
                trigger: teaser,
                start: 'top bottom',
                scrub: 1
            },
            y: -150,
        });
    });

// Teaser content
    bigTeasers.forEach(teaser => {
        gsap.to(teaser.querySelector('.content-wrapper .content'), {
            scrollTrigger: {
                trigger: teaser,
                start: 'top bottom',
                scrub: 0.5,
            },
            y: -150,
        });
    });


    /*
     * Reviews
     */
    const reviews = gsap.utils.toArray('.field--name-field-reviews > .field__item');

    reviews.forEach((review, index) => {
        gsap.from(review, {
            scrollTrigger: {
                trigger: '.reviews',
                start: 'top 70%',
                end: 'bottom bottom',
            },
            scale: 1.3,
            delay: index * 0.3,
            y: index * 40
        });

        gsap.from(review.querySelector('.blur-overlay'), {
            scrollTrigger: {
                trigger: '.reviews',
                start: 'top 70%',
                end: 'bottom bottom',
            },
            opacity: 1,
            delay: index * 0.3,
        });
    });


    /*
     * Everything with a .animate-text wrapper
     */
    const text = gsap.utils.toArray('.animate-text:not(.animation-delay)');

    text.forEach(item => {
        gsap.to(item.querySelectorAll('*'), {
            scrollTrigger: {
                trigger: item,
                start: 'top 95%',
                once: true,
            },
            y: 0,
            opacity: 1,
            duration: 1,
        });
    })

    const headerText = gsap.utils.toArray('.animate-text.animation-delay');

    headerText.forEach(item => {
        gsap.to(item.querySelectorAll('*'), {
            y: 0,
            opacity: 1,
            duration: 1,
            delay: 1
        });
    })


    /*
     * Gradient shapes
     */
    const gradientShapes = gsap.utils.toArray('.gradient-shapes:not(.horizontal)');

    gradientShapes.forEach((gradientShape) => {

        const shapes = gsap.utils.toArray(gradientShape.querySelectorAll('.shape'));

        shapes.forEach((shape, index) => {
            gsap.from(shape, {
                scrollTrigger: {
                    trigger: gradientShape,
                    start: 'top 80%',
                    once: true,
                },
                x: 50,
                opacity: 0,
                duration: 1,
                delay: index * 0.2
            });
        });
    });


    /*
     * Gradient shapes horizontal
     */
    const gradientShapesHorizontal = gsap.utils.toArray('.gradient-shapes.horizontal:not(.no-animation)');

    gradientShapesHorizontal.forEach((gradientShape) => {

        const shapes = gsap.utils.toArray(gradientShape.querySelectorAll('.shape'));

        shapes.forEach((shape, index) => {
            gsap.from(shape, {
                scrollTrigger: {
                    trigger: gradientShape,
                    start: 'top 80%',
                    once: true,
                },
                y: 50,
                opacity: 0,
                duration: 1,
                delay: index * 0.2
            });
        });
    });

    gsap.to('.circle-slider', {
        opacity: 1,
        duration: 1,
        delay: 2
    });

    gsap.to('.team-member', {
        scrollTrigger: {
            trigger: '.team',
            start: 'top center',
            end: 'bottom bottom',
            scrub: 2,
        },
        y: 0,
        duration: 1
    });

    gsap.to('.page-node-type-topic-page .topic-item', {
        scrollTrigger: {
            trigger: '.gradient-content',
            start: 'top center',
            end: 'bottom bottom',
            scrub: 2,
        },
        y: 0,
        duration: 1
    });

    /*
     * Paragraph: Image with text above
     */
    const paragraphsImageWithText = gsap.utils.toArray('.paragraph--type--image-with-text-above');

    paragraphsImageWithText.forEach(paragraph => {

        gsap.from(paragraph.querySelector('.field--name-field-text'), {
            scrollTrigger: {
                trigger: paragraph.querySelector('.field--name-field-text'),
                start: 'top 80%',
                end: 'bottom 80%',
                scrub: 1,
                once: true,
            },
            scale: 1.5,
            opacity: 0
        });

        gsap.from(paragraph.querySelector('.field--name-field-image'), {
            scrollTrigger: {
                trigger: paragraph,
                start: 'top center',
                end: '30% center',
                scrub: 1,
                once: true,
            },
            scale: 1.4,
            y: 250,
        });
    });


    /*
     * Paragraph: Video with text above
     */
    const paragraphsVideoWithText = gsap.utils.toArray('.paragraph--type--video-with-text-above');

    paragraphsVideoWithText.forEach(paragraph => {

        gsap.from(paragraph.querySelector('.field--name-field-text'), {
            scrollTrigger: {
                trigger: paragraph.querySelector('.field--name-field-text'),
                start: 'top 80%',
                end: 'bottom 80%',
                scrub: 1,
                once: true,
            },
            scale: 1.5,
            opacity: 0
        });

        gsap.from(paragraph.querySelector('.vue-iframe-wrapper'), {
            scrollTrigger: {
                trigger: paragraph,
                start: 'top center',
                end: '30% center',
                scrub: 1,
                once: true,
            },
            scale: 1.4,
            y: 250,
        });
    });


    /*
     * Occasion overview teaser
     */
    gsap.from('.view-occasion-overview-teaser-homepage .car-image', {
        scrollTrigger: {
            trigger: '.view-occasion-overview-teaser-homepage',
            start: 'top center',
        },
        x: '100vw',
        duration: 1.5
    });

    gsap.from('.view-occasions-overzicht-teaser .car-image', {
        scrollTrigger: {
            trigger: '.view-occasions-overzicht-teaser',
            start: 'top center',
        },
        x: '100vw',
        duration: 1.5
    });



}

